export const SAAS_ADMINISTRATION_TAB_DEFINITIONS = [
  ['institutions', 'Institutions'],
  ['license-features', 'License & Features'],
  ['support', 'Support'],
];

export const SAAS_GLOBAL_MARKETPLACE_SECTION = 'marketplace';
export const SAAS_ADMINISTRATION_SECTION_EVENT = 'disasterms:saas-administration-section-selected';

export const isGlobalMarketplaceSearch = (search = '') => (
  new URLSearchParams(search).get('section') === SAAS_GLOBAL_MARKETPLACE_SECTION
);

export const globalMarketplaceHref = () => (
  `/saas-administration?section=${SAAS_GLOBAL_MARKETPLACE_SECTION}`
);
